import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e50f614c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "batch-delivery-modal" }
const _hoisted_2 = { class: "confirm-order-content" }
const _hoisted_3 = { class: "confirm-order-title" }
const _hoisted_4 = { class: "margin-16" }
const _hoisted_5 = { class: "text-rt confirm-btns" }

import { t, lang } from '@/plugins/i18n'
import { ref, nextTick, toRaw } from 'vue'


export default /*#__PURE__*/_defineComponent({
  props: ['orderNum'],
  emits: ['success'],
  setup(__props, { expose, emit }) {

const props = __props



const visible = ref(false)

const open = () => {
  visible.value = true
}
const cancel = () => {
  visible.value = false
}

const commit = () => {
  cancel()
  emit('success')
}

expose({
  open
})

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      "destroy-on-close": "",
      onClose: cancel,
      draggable: "",
      width: 400
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('批量优先发货')), 1)
          ]),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('选择订单数')) + "：" + _toDisplayString(props.orderNum), 1),
          _createElementVNode("p", null, _toDisplayString(_unref(t)('确认分纳发送吗')), 1),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_button, {
              type: "default",
              onClick: cancel
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: commit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('确定')), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})